import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import CommonPageHeader from '../components/common/CommonPageHeader';
import MultiProjectGanttView from '../components/projects/MultiProjectGanttView';
import LoadingScreen from '../components/common/LoadingScreen';
import { ChartBarIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const ProjectsGantt: React.FC = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const { hasAccess } = usePermissions();
  const navigate = useNavigate();

  // Jogosultság ellenőrzés
  if (!hasAccess('projects')) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">{t('common.errors.noPermission')}</div>
      </div>
    );
  }

  // Organization ellenőrzés
  if (!user?.organizationId) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Nincs szervezet hozzárendelve</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <CommonPageHeader
        title="Projektek idővonala"
        subtitle="Aktuális projektek és feladataik idővonalon"
        icon={ChartBarIcon}
      >
        <button
          onClick={() => navigate('/projects')}
          className="px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-md text-sm font-medium hover:bg-white/30 transition-colors flex items-center gap-2 border border-white/30"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          <span>Vissza a projektekhez</span>
        </button>
      </CommonPageHeader>

      <div className="w-full px-4 py-4 md:px-6 md:py-6">
        <MultiProjectGanttView />
      </div>
    </div>
  );
};

export default ProjectsGantt;
